import pageFetcher from './page-fetcher';
import siteLoader from './site-loader';
import pageCreator from './page-creator';
import pageSettings from './page-settings';
import siteExporter from './site-exporter';
import pageRemoval from './page-removal';
import pageUsedBlocksTracker from './page-used-blocks-tracker';
import foldersValidator from './folders-validator';

export default {
  pageFetcher,
  siteLoader,
  pageCreator,
  pageSettings,
  siteExporter,
  pageRemoval,
  pageUsedBlocksTracker,
  foldersValidator,
};
